export function validateName(name) {
  var re = /^[ A-Za-z-.\s]{1,}$/i;
  return re.test(name);
}

export function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validateMessage(message) {
  var re = /^.+$/;
  return re.test(message);
}

export function validateDate(date) {
  var re = /^\d{2}[./]\d{2}[./]\d{4}$/;
  var re2 = /^\d{4}[./-]\d{2}[./-]\d{2}$/;
  if (re.test(date)) {
    return true;
  } else if (re2.test(date)) {
    return true;
  } else {
    return false;
  }
}
